<template>
  <div class="steven-group-wrapper">
    <div
      class="steven-group-container group-container"
      :class="group.id"
      :id="group.id"
      :style="`z-index: ${1000 - index}`"
    >
      <div class="group-box steven-group-border-box"></div>
      <div v-for="(item, index) in group.children" :key="item.id">
        <ElementBox
          :type="item.type"
          :element="item"
          :index="index"
          :ref="item.id"
          v-if="item.type !== 'group' && !item.isHidden"
        >
        </ElementBox>
        <GroupBox
          v-else-if="!item.isHidden"
          :group="item"
          :id="item.id"
          :index="index"
        ></GroupBox>
      </div>
    </div>
  </div>
</template>

<script>
import ElementBox from './ElementBox';

export default {
  name: 'steven-group-box-item',
  props: ['group', 'id', 'index'],
  components: {
    ElementBox
  }
};
</script>

<style lang='less' scoped>
.group-container {
  position: relative;
  width: 0;
  height: 0;
  left: 0;
  top: 0;
}

.group-box {
  position: absolute;
  width: 0;
  height: 0;
  left: 10000px;
  top: 10000px;
  z-index: 10000;
  background: rgba(255, 0, 0, 0);
  outline-offset: 0px;
  color: #fff;
}

.group-box.selected {
  outline: solid 1px rgba(0, 153, 0, 0.5);
  // background-color:  rgba(0, 153, 0, 0.5);
}

.group-box.editiing {
  outline: dashed 0px rgba(255, 0, 0, 0.5);
  // background-color:  rgba(255, 0, 0, 0.5);
  pointer-events: none;
}

.group-over-box {
  position: absolute;
  width: 0;
  height: 0;
  left: 10000px;
  top: 10000px;
  z-index: 1000;
  border: solid 0px rgba(0, 0, 0, 0.6);
  pointer-events: none;
}
</style>
